<form [formGroup]="form">
  <rt-form-field margin-bottom>
    <rt-label>{{ 'app.pricing.billing_address_form.company_name' | translate }}</rt-label>
    <rt-input
      variant="rounded"
      [maxLength]="255"
      formControlName="companyName"
      placeholder=""
      [disabled]="isManual"
    >
    </rt-input>
  </rt-form-field>

  <rt-form-field margin-bottom>
    <rt-label>{{ 'app.pricing.billing_address_form.country' | translate }}</rt-label>
    <rt-select
      formControlName="countryCode"
      [disabled]="countries.length === 0 || isManual"
      [includeEmptyOption]="false"
      [items]="countries"
    ></rt-select>
  </rt-form-field>

  @if (form.contains('stateCode')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ 'app.pricing.billing_address_form.region' | translate }}</rt-label>
      <rt-select
        formControlName="stateCode"
        [includeEmptyOption]="false"
        [items]="regions"
      ></rt-select>
    </rt-form-field>
  }

  <rt-form-field margin-bottom>
    <rt-label>{{ 'app.pricing.billing_address_form.address' | translate }}</rt-label>
    <rt-input variant="rounded" [maxLength]="255" formControlName="address" placeholder="">
    </rt-input>
  </rt-form-field>

  <div layout-space-between layout-horizontal>
    <rt-form-field margin-bottom margin-right>
      <rt-label>{{ 'app.pricing.billing_address_form.city' | translate }}</rt-label>
      <rt-input
        variant="rounded"
        [maxLength]="255"
        formControlName="city"
        placeholder=""
        width="100%"
      >
      </rt-input>
    </rt-form-field>

    <rt-form-field margin-bottom>
      <rt-label>{{ 'app.pricing.billing_address_form.postal_code' | translate }}</rt-label>
      <rt-input
        variant="rounded"
        [maxLength]="255"
        formControlName="postalCode"
        placeholder=""
        width="100%"
      >
      </rt-input>
    </rt-form-field>
  </div>

  @if (form.contains('vatNumber')) {
    <rt-form-field margin-bottom>
      <rt-label margin-bottom-small-xx>
        {{ 'app.pricing.billing_address_form.vat_number' | translate }}
        <rt-icon-help-with-dropdown
          [link]="'app.support_resources.vat_validation' | translate"
          [infoText]="'app.pricing.billing_address_form.vat_number_hint' | translate"
          margin-left-small-x
        >
        </rt-icon-help-with-dropdown>
      </rt-label>
      <rt-input variant="rounded" formControlName="vatNumber" [disabled]="isManual"></rt-input>
    </rt-form-field>
  }
</form>
